import { Component, AfterViewInit, OnInit } from '@angular/core';
import { BentoRibbonTile } from '@bento/bento-ng';
import * as _ from 'lodash';
import { LayoutState } from '../../store/reducers/layout.reducer';
import { AllTilesRequested, TabClick } from '../../store/actions/layout.actions';
import { Store, select } from '@ngrx/store';
import { selectAllTiles, selectRoutedTab } from '../../store/selectors/layout.selector';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { LayoutService } from 'src/app/core/services/layout.service';
@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnInit, AfterViewInit {

  tileItems: BentoRibbonTile[] = [];
  routedTab: string;

  constructor(private store: Store<LayoutState>, private router: Router, private  service: LayoutService) { }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.service.getFirmFlowPermision().subscribe(res => {
      this.store.dispatch(AllTilesRequested());
    });
   
    this.store.pipe(select(selectRoutedTab)).subscribe(res => {
      this.routedTab = res;
    });
    this.store.pipe(select(selectAllTiles)).subscribe(
      (res) => {
        this.tileItems = [];
        _.forEach(res, v => {
          const v1 = v as any;
          if (this.tileItems && v1.isVisible) {
            this.tileItems.push(
              new BentoRibbonTile(
                v.count,
                v.firstLineText,
                v.secondLineText,
                tile => this.store.dispatch(TabClick({ selectedTile: v })),
                v.linksText,
                onLinkClick => this.onTileLinkClick(v['linkRoute'])
              ));
          }
        });
        if (this.tileItems[0]) {
          let index = 0;
          _.forEach(this.tileItems, v => {
            index++;
            if (v.header === this.routedTab) {
              this.tileItems[index - 1].select();
            }
          })
          //this.tileItems[0].select();
        }
      }
    );
  }

  onTileLinkClick(evt) {
    const url = environment.strrooturl;
    if (evt === 'My Work') {

      window.parent.location.href = '/trpc/myworkframeset.asp';
    } else if (evt === 'My Recent Documents') {
      window.parent.location.href = url + 'Dashboard/DashboardSetUpFrame.asp?route=dsrw';
    } else {
      this.router.navigate([evt]);
    }

  }

}
